import * as React from 'react';
import type { SVGProps } from 'react';
const SvgImageLock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    color="currentColor"
    {...props}
  >
    <path d="M20 5.18V4a3 3 0 0 0-6 0v1.18A3 3 0 0 0 12 8v2a3 3 0 0 0 3 3h4a3 3 0 0 0 3-3V8a3 3 0 0 0-2-2.82M16 4a1 1 0 0 1 2 0v1h-2Zm4 6a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1Zm-1 5a1 1 0 0 0-1 1v3a.9.9 0 0 1-.18.53l-8.41-8.41a2.86 2.86 0 0 0-3.93 0L4 12.6V7a1 1 0 0 1 1-1h5a1 1 0 0 0 0-2H5a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-3a1 1 0 0 0-1-1M5 20a1 1 0 0 1-1-1v-3.57l2.9-2.9a.79.79 0 0 1 1.09 0L15.46 20Z" />
  </svg>
);
export default SvgImageLock;
